import { jsxs as r, Fragment as m, jsx as l } from "react/jsx-runtime";
import { forwardRef as g, useRef as z, useImperativeHandle as V } from "react";
import { FAIcon as u, Theme as k } from "@nextgen-web-framework/all";
import './assets/FullScreenModal.css';const C = "#ffffff", _ = "#396e75", f = "#e5fdff", h = "#546223", b = "#f0fae5", p = "#a65523", B = "#fff1e8", j = "#7f3e3e", R = "#ffe2e2", G = "#62625a", N = "#f8f8e7", O = "#38539a", w = "#707070", v = "#c8f8d1", y = "#87c9c8", W = "#5291b1", A = "rgba(82, 145, 177, 0.1019607843)", F = "#445685", S = "#181d61", Y = "rgba(24, 29, 97, 0.1019607843)", x = "#5969d6", I = "#ea999d", M = "#b6577e", P = "rgba(182, 87, 126, 0.1019607843)", $ = "#7e3e80", H = "#1e247f", K = "rgba(30, 36, 127, 0.1019607843)", L = "#da7600", T = "#107f47", q = "#d91734", D = "_html_1ljul_46", a = {
  amwayWhite: C,
  darkBlue: _,
  lightBlue: f,
  darkGreen: h,
  lightGreen: b,
  darkOrange: p,
  lightOrange: B,
  darkRed: j,
  lightRed: R,
  darkYellow: G,
  lightYellow: N,
  darkPurple: O,
  darkGrayOnWhite: w,
  dataVizColor1: v,
  dataVizColor2: y,
  dataVizColor3: W,
  dataVizColor3Background: A,
  dataVizColor4: F,
  dataVizColor5: S,
  dataVizColor5Background: Y,
  dataVizColor6: x,
  dataVizColor7: I,
  dataVizColor8: M,
  dataVizColor8Background: P,
  dataVizColor9: $,
  dataVizColor10: H,
  dataVizColor10Background: K,
  dataVizAlertOrange: L,
  dataVizSuccessGreen: T,
  dataVizWarningRed: q,
  "no-visible": "_no-visible_1ljul_42",
  html: D,
  "full-screen-banner": "_full-screen-banner_1ljul_80",
  "modal-dialog": "_modal-dialog_1ljul_85",
  "modal-container": "_modal-container_1ljul_96",
  "modal-img-container": "_modal-img-container_1ljul_111",
  "modal-icon-section": "_modal-icon-section_1ljul_116",
  "close-icon": "_close-icon_1ljul_130",
  "modal-backdrop": "_modal-backdrop_1ljul_136",
  "skeleton-loading": "_skeleton-loading_1ljul_1"
}, E = g(
  ({ children: i, closeOnBackdropClick: c, onClose: t }, s) => {
    const d = z();
    V(s, () => d.current);
    const n = (o, e) => {
      e == null || e(o);
    };
    return /* @__PURE__ */ r(m, { children: [
      /* @__PURE__ */ l("section", { className: a["modal-dialog"], children: /* @__PURE__ */ r("section", { className: `${a["modal-container"]}`, ref: d, children: [
        /* @__PURE__ */ l("div", { className: `${a["modal-content-container"]}`, children: i }),
        /* @__PURE__ */ l("div", { className: a["modal-icon-section"], children: /* @__PURE__ */ l(
          u,
          {
            className: a["close-icon"],
            "data-testid": "close-icon-test-id",
            "data-pod-name": "commerce",
            iconName: "close",
            theme: k.BLACK,
            onClick: (o) => n(o, t)
          }
        ) })
      ] }) }),
      /* @__PURE__ */ l(
        "div",
        {
          className: a["modal-backdrop"],
          onClick: (o) => c && n(o, t),
          "aria-hidden": "true",
          "data-testid": "backdrop-testid",
          "data-pod-name": "commerce"
        }
      )
    ] });
  }
);
E.displayName = "FullScreenModal";
export {
  E as F,
  a as s
};
//# sourceMappingURL=FullScreenModal-14331a44.mjs.map
